import { Button, styled } from "@mui/material";

const DialogButton = styled(Button)(({ theme }) => ({
    width: "95%",
    textTransform: "none",
    height: "100%",
}));

export default DialogButton